import {LOCALE} from '~/pages/category-profile/domain/locale';

type Format = {format: Intl.NumberFormat; iso: boolean};

const FORMATS = new Map<string, Format>();

function currencyFormat(currency: string, small: boolean): Format {
    const key = `${currency}|${small}`;
    let found = FORMATS.get(key);
    if (!found) {
        const digits = small ? {maximumSignificantDigits: 3} : {minimumFractionDigits: 2, maximumFractionDigits: 2};
        try {
            // The app's currency notation (as `ProfileStore.currencyFormat`); only the precision differs, see below.
            found = {format: new Intl.NumberFormat(LOCALE, {style: 'currency', currency, ...digits}), iso: true};
        } catch {
            // Not an ISO 4217 code (data from before the server checked it): the number, prefixed with the text.
            found = {format: new Intl.NumberFormat(LOCALE, digits), iso: false};
        }
        FORMATS.set(key, found);
    }
    return found;
}

/**
 * A unit price in `currency` (ISO code), in the app's currency notation and locale. Unit prices span many orders of
 * magnitude (0.0021 per gram, 12,400 per machine), so below 1 they keep three significant digits where spend would
 * round them to 0.00.
 */
export function formatUnitPrice(v: number | null | undefined, currency: string): string {
    if (v === null || v === undefined || !Number.isFinite(v)) return '—';
    const a = Math.abs(v);
    const {format, iso} = currencyFormat(currency, a > 0 && a < 1);
    const text = format.format(v);
    return iso || !currency.trim() ? text : `${currency.trim()} ${text}`;
}

/** "€1.20 / kg". */
export function perUnit(price: string, unit: string): string {
    return `${price} / ${unit}`;
}
